import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { MyProfileResponse as Profile } from "@dripit/types";

export interface ProfileState {
  data: Profile | null;
  showOnboarding: boolean;
  fromQuickTour: boolean;
  isLoading: boolean;
  error: Error | string | null;
}

const initialState: ProfileState = {
  data: null,
  showOnboarding: false,
  fromQuickTour: false,
  isLoading: false,
  error: null,
};

export const profileSlice = createSlice({
  name: "profile",
  initialState,
  reducers: {
    setProfile: (state, action: PayloadAction<ProfileState["data"]>) => {
      state.data = action.payload;
    },
    setIsLoading: (state, action: PayloadAction<ProfileState["isLoading"]>) => {
      state.isLoading = action.payload;
    },
    setError: (state, action: PayloadAction<ProfileState["error"]>) => {
      state.error = action.payload;
    },
    setShowOnboarding: (
      state,
      action: PayloadAction<
        boolean | { open?: boolean; fromQuickTour: boolean }
      >
    ) => {
      if (typeof action.payload === "boolean") {
        state.showOnboarding = action.payload;
      } else {
        state.showOnboarding = action.payload.open ?? true;
        state.fromQuickTour = action.payload.fromQuickTour;
      }
    },
    clearProfileState: () => initialState,
  },
});

export const actions = profileSlice.actions;

export default profileSlice.reducer;
